'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _chunkify = require('./chunkify');

var _chunkify2 = _interopRequireDefault(_chunkify);

/**
 * This is the format of each style object in the ArticleFormat spec.
 *
 * @typedef {Object} ArticleFormatStyle
 * @property {string} style - The style to apply
 * @property {number} offset - The start offset of the style
 * @property {number} length - The number of character code points this style applies to
 */

/**
 * Takes a map of functions and returns a function that turns a text and an array of styles into calls to the
 * corresponding functions in the map. If an entry is not handled by the map, then that style is ignored.
 *
 * @param {object} handlers A map of functions, where each key corresponds to a style and the value is a function
 * that is called with the text to be transformed.
 * @return {Function} The configured stylizr function
 */
function stylizr() {
    var handlers = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    /**
     * This function corresponds to the configured stylizr instance. It uses `handlers` from its closure
     * to turn a text and an array of styles into function calls to the `handlers` map. This means that the result
     * is an array of the type the `handlers`-functions returns.
     *
     * @param {string} subject The text to apply `styles` to
     * @param {ArticleFormatStyle[]} subjectStyles An array of styles according to the article format spec
     * @return {Array<*>} `text` with `styles` applied
     */
    return function stylizrInstance() {
        var subject = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
        var subjectStyles = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

        var chunks = (0, _chunkify2['default'])(subject, subjectStyles);

        var textComponents = chunks.reduce(function (components, _ref, chunkIx) {
            var text = _ref.text;
            var styles = _ref.styles;

            components.push(styles.reduce(function (acc, _ref2, styleIx) {
                var type = _ref2.type;

                var data = _objectWithoutProperties(_ref2, ['type']);

                if (handlers[type]) {
                    return handlers[type](acc, chunkIx + '_' + styleIx + '_' + type, data);
                } else {
                    if (process.env.NODE_ENV === 'development') {
                        console.warn('stylizr: Ignored unhandled style "' + type + '" for text "' + acc + '"'); // eslint-disable-line no-console
                    }
                    return acc;
                }
            }, text));

            return components;
        }, []);

        return textComponents.length === 1 ? textComponents[0] : textComponents;
    };
}

exports['default'] = stylizr;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@aftonbladet/stylizr/lib/stylizr.js
 ** module id = 454
 ** module chunks = 1
 **/